import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { formatCLP, formatDate } from "../../lib/format";
import { MagnifyingGlass, ArrowRight, UsersThree } from "@phosphor-icons/react";
import { TagsList } from "../../components/Tags";

export default function AdvisorClients() {
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");
  const [tagCatalog, setTagCatalog] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/users", { params: { q, role: "client" } }).then((r) => setClients(r.data));
  }, [q]);

  useEffect(() => {
    api.get("/tags").then((r) => setTagCatalog(r.data)).catch(() => {});
  }, []);

  const startChat = async (id) => {
    try {
      const { data } = await api.post("/chat/start", null, { params: { client_id: id } });
      navigate(`/app/chat`);
    } catch {}
  };

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Cartera · Asesor</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Tus clientes</h1>
      </header>

      <div className="bento p-4 flex items-center gap-3">
        <MagnifyingGlass size={20} weight="duotone" className="text-inkMuted" />
        <input
          data-testid="clients-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por nombre, RUT, correo o teléfono…"
          className="flex-1 h-10 bg-transparent focus:outline-none"
        />
      </div>

      <div className="bento">
        <div className="px-6 py-4 border-b border-hairline flex items-center justify-between">
          <h2 className="font-display text-xl font-bold flex items-center gap-2"><UsersThree size={20} weight="duotone" /> {clients.length} clientes</h2>
        </div>
        {clients.length === 0 ? (
          <div className="p-12 text-center text-inkMuted text-sm">Sin resultados.</div>
        ) : (
          <table className="w-full text-sm" data-testid="clients-table">
            <thead>
              <tr className="label-mono border-b border-hairline">
                <th className="text-left px-6 py-3">Cliente</th>
                <th className="text-left px-6 py-3">RUT</th>
                <th className="text-left px-6 py-3">Contacto</th>
                <th className="text-right px-6 py-3">Saldo</th>
                <th className="text-left px-6 py-3">Alta</th>
                <th className="text-right px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((c) => (
                <tr key={c.id} className="border-b border-hairline hover:bg-bg">
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 bg-forest text-bg flex items-center justify-center font-display font-bold flex-shrink-0">{c.name?.[0]}</div>
                      <div className="min-w-0">
                        {(c.tags || []).length > 0 && tagCatalog.length > 0 && (
                          <div className="mb-1">
                            <TagsList tagIds={c.tags} catalog={tagCatalog} size="xs" />
                          </div>
                        )}
                        <div className="font-semibold">{c.name}</div>
                        <div className="label-mono">{c.status}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-3 font-mono">{c.rut}</td>
                  <td className="px-6 py-3">
                    <div>{c.email}</div>
                    <div className="label-mono">{c.phone}</div>
                  </td>
                  <td className="px-6 py-3 text-right font-mono font-medium">{formatCLP(c.balance)}</td>
                  <td className="px-6 py-3 font-mono text-xs text-inkMuted">{formatDate(c.created_at)}</td>
                  <td className="px-6 py-3 text-right space-x-2">
                    <button onClick={() => startChat(c.id)} className="h-9 px-3 border border-hairline text-xs" data-testid={`chat-${c.id}`}>Chatear</button>
                    <Link to={`/app/clientes/${c.id}`} className="h-9 px-3 bg-forest text-bg text-xs inline-flex items-center gap-1" data-testid={`open-${c.id}`}>
                      Abrir <ArrowRight size={12} weight="bold" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
